// extracted by mini-css-extract-plugin
module.exports = {"upload":"ImageUpload_upload__1tFsL"};